module.exports = __webpack_public_path__ + "static/media/pikaSad.d710e24e.webp";